import React, { useEffect, useState } from "react";
import { object, array, bool, string } from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";

import Organism1 from "./Organism1";
import Organism2 from "./Organism2";
import Organism3 from "./Organism3";
import CollectionTitleWithArrow from "../../atoms/CollectionTitleWithArrow";
import { getSlug, getCollectionName } from "../../utils/utils";

import "./sixStories1AdWithTagSearch.m.css";

const SixStories1AdWithTagSearch = ({
  collection,
  sections,
  isSectionComponent = false,
  firstStoriesSet,
  widgetUrl = null,
  widgetHeight = null,
  domainSlug,
  pageType,
  publisherAttributes,
}) => {
  const [isDesktop, setIsDesktop] = useState(false);
  useEffect(() => {
    setIsDesktop(global.deviceWidth >= 1264);
  }, []);

  const showCollectionName = get(collection, ["associated-metadata", "show_collection_name_website"], null);
  const list = !firstStoriesSet ? collection.items.filter((item) => item.type === "story") : firstStoriesSet;
  const storyList = !firstStoriesSet ? list.slice(0, 11) : firstStoriesSet;
  const navigateTo = get(collection, ["associated-metadata", "navigate_to"], "");
  const navigateToTitle = get(collection, ["associated-metadata", "navigate_to_title"], "");
  const sectionPageCustomStyleBangla = pageType === "section-page" ? `${publisherAttributes.lang}-story-card` : "";

  const collectionName = getCollectionName(collection, navigateToTitle);
  const collectionSlug = navigateTo ? `/${navigateTo}` : getSlug(collection, sections, domainSlug);
  const adSlotId = get(collection, ["associated-metadata", "ad_slot_id"], "default_ad_slot");

  if (!storyList.length) {
    return null;
  }

  return (
    <div styleName="base" className="six-stories-1ad-with-tag-search" data-testid="six-stories-tag">
      {showCollectionName && (
        <CollectionTitleWithArrow
          collectionName={collectionName}
          collectionSlug={collectionSlug}
          headlineClassName="collection-name-arrow"
          updatedFont={true}
        />
      )}
      <div styleName="wrapper">
        <div>
          <Organism1
            storyList={isDesktop ? storyList.slice(0, 3) : storyList.slice(0, 6)}
            updatedFont={true}
            langClass={sectionPageCustomStyleBangla}
          />
          <Organism2 storyList={storyList.slice(3, 7)} className="organism-2" updatedFont={true} />
        </div>
        <Organism3
          className="organism-3"
          isSectionComponent={isSectionComponent}
          widgetUrl={widgetUrl}
          widgetHeight={widgetHeight}
          collectionSlug={collectionSlug}
          adSlotId={adSlotId}
        />
      </div>
    </div>
  );
};

SixStories1AdWithTagSearch.propTypes = {
  collection: object,
  sections: array,
  isSectionComponent: bool,
  firstStoriesSet: array,
  widgetUrl: string,
  widgetHeight: string,
  domainSlug: string,
  pageType: string,
  publisherAttributes: object,
};

const mapStateToProps = (state) => ({
  sections: get(state, ["qt", "config", "sections"], []),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
  pageType: get(state, ["qt", "pageType"], ""),
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

export default connect(mapStateToProps)(SixStories1AdWithTagSearch);
